import React, { useState } from "react";
import { Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import appicon from "../assets/icons/app-development.png";
import web from "../assets/icons/web-development.png";
import consult from "../assets/icons/consultant.png";
import market from "../assets/icons/globalization.png";

function Development() {
  const [hoveredCard, setHoveredCard] = useState(null);

  const handleMouseEnter = (cardId) => {
    setHoveredCard(cardId);
  };

  const handleMouseLeave = () => {
    setHoveredCard(null);
  };

  return (
    <div
      id="development"
      className="text-center"
      style={{
        background: "#ffffff",
      }}
    >


     <div  className="col-md-10 col-md-offset-1 section-title"  >
        <h2 style={{ color: "#000" }}>What we do?</h2>
      </div>
      <Grid  container spacing={3} paddingTop={1} padding={1} paddingBottom={20}>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={4}
            style={{
              padding: 10,
              borderTopLeftRadius: 100,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 100,
              borderBottomLeftRadius: 10,
              backgroundColor: "#2234ae",
              backgroundImage: "linear-gradient(315deg, #2234ae 0%, #191714 100%)"
 
            }}
          >
            <Box
              sx={{
                justifyContent: "center",
                padding: 2,
                textAlign: "center",
                height: 350,
              }}
              onMouseEnter={() => handleMouseEnter("app")}
              onMouseLeave={handleMouseLeave}
            >
              {hoveredCard === "app" ? (
                <img
                  style={{
                    width: 100,
                    background:
                      "linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)",
                    borderRadius: 20,
                  }}
                  src={appicon}
                  alt="appicon"
                />
              ) : (
                <img
                  style={{
                    width: 250,

                    borderRadius: 20,
                  }}
                  src={appicon}
                  alt="appicon"
                />
              )}

              <h3 style={{ fontWeight: "bold" ,color: "#fff" }}>
                Custom Mobile App Development
              </h3>
              {hoveredCard === "app" ? (
                <p style={{color: "#fff",textAlign: "left" }}>
                  Imagine having a powerful mobile app that perfectly
                  complements your business strategy. Our skilled developers
                  bring your mobile app ideas to life, crafting user-friendly
                  and feature-rich applications for iOS and Android platforms.
                </p>
              ) : null}
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={4}
            style={{
              padding: 10,
              borderTopLeftRadius: 100,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 100,
              borderBottomLeftRadius: 10,
              backgroundColor: "#2234ae",
              backgroundImage: "linear-gradient(315deg, #2234ae 0%, #191714 100%)"

            }}
          >
            <Box
              sx={{
                justifyContent: "center",
                padding: 2,
                textAlign: "center",
                height: 350,
              }}
              onMouseEnter={() => handleMouseEnter("web")}
              onMouseLeave={handleMouseLeave}
            >
              {hoveredCard === "web" ? (
                <img
                  style={{
                    width: 100,
                    background:
                      "linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)",
                    borderRadius: 20,
                  }}
                  src={web}
                  alt="webicon"
                />
              ) : (
                <img
                  style={{
                    width: 250,

                    borderRadius: 20,
                  }}
                  src={web}
                  alt="webicon"
                />
              )}

              <h3 style={{ fontWeight: "bold" ,color: "#fff" }}>
                Web Application Development
              </h3>
              {hoveredCard === "web" ? (
                <p style={{color: "#fff" ,textAlign: "left"}}>
                  Need a dynamic and engaging web application? We excel in
                  developing custom web applications that cater to your specific
                  needs. From simple web portals to complex enterprise
                  solutions, we deliver exceptional results.
                </p>
              ) : null}
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={4}
            style={{
              padding: 10,
              borderTopLeftRadius: 100,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 100,
              borderBottomLeftRadius: 10,
              backgroundColor: "#2234ae",
              backgroundImage: "linear-gradient(315deg, #2234ae 0%, #191714 100%)"
 
            }}
          >
            <Box
              sx={{
                justifyContent: "center",
                padding: 2,
                textAlign: "center",
                height: 350,
              }}
              onMouseEnter={() => handleMouseEnter("consult")}
              onMouseLeave={handleMouseLeave}
            >
              {hoveredCard === "consult" ? (
                <img
                  style={{
                    width: 100,
                    background:
                      "linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)",
                    borderRadius: 20,
                  }}
                  src={consult}
                  alt="consulticon"
                />
              ) : (
                <img
                  style={{
                    width: 250,

                    borderRadius: 20,
                  }}
                  src={consult}
                  alt="consulticon"
                />
              )}

              <h3 style={{ fontWeight: "bold" ,color: "#fff" }}>Consultancy Services</h3>
              {hoveredCard === "consult" ? (
                <p style={{color: "#fff" ,textAlign: "left"}}>
                  Not sure where to begin? Our experienced consultants offer
                  valuable guidance and strategic insights. We'll help you
                  assess your tech needs, identify the best solutions, and
                  develop a roadmap for success.
                </p>
              ) : null}
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6} lg={3}>
          <Paper
            elevation={4}
            style={{
              padding: 10,
              borderTopLeftRadius: 100,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 100,
              borderBottomLeftRadius: 10,
              backgroundColor: "#2234ae",
              backgroundImage: "linear-gradient(315deg, #2234ae 0%, #191714 100%)"
 
            }}
          >
            <Box
              sx={{
                justifyContent: "center",
                padding: 2,
                textAlign: "center",
                height: 350,
              }}
              onMouseEnter={() => handleMouseEnter("market")}
              onMouseLeave={handleMouseLeave}
            >
              {hoveredCard === "market" ? (
                <img
                  style={{
                    width: 100,
                    background:
                      "linear-gradient(to right, #7028e4 0%, #e5b2ca 100%)",
                    borderRadius: 20,
                  }}
                  src={market}
                  alt="marketicon"
                />
              ) : (
                <img
                  style={{
                    width: 250,

                    borderRadius: 20,
                  }}
                  src={market}
                  alt="marketicon"
                />
              )}

              <h3 style={{ fontWeight: "bold" ,color: "#fff" }}>Digital Migration Services</h3>
              {hoveredCard === "market" ? (
                <p style={{color: "#fff",textAlign: "left" }}>
                  Looking to seamlessly transition your operations to the
                  digital realm? We provide comprehensive digital migration
                  services, ensuring a smooth and secure transfer of your data
                  and processes to the latest technologies.
                </p>
              ) : null}
            </Box>
          </Paper>
        </Grid>
      </Grid>


    </div>
  );
}

export default Development;
